/**
 * PlanBadge — small badge shown in the app header/nav indicating the user's plan.
 * Free users see a subtle "Free" badge; Pro users see a "Pro" badge.
 */
import { Crown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useUserPlan } from "@/hooks/useUserPlan";

export function PlanBadge() {
  const { isPro, isLoading } = useUserPlan();

  if (isLoading) return null;

  if (isPro) {
    return (
      <Badge
        variant="default"
        className="gap-1 bg-amber-500 text-white hover:bg-amber-500"
      >
        <Crown size={10} />
        Pro
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="text-muted-foreground">
      Free
    </Badge>
  );
}
